import React, { useEffect, useState } from "react";
import { Switch, Route } from "react-router-dom";
import firebase from "firebase";
import TopBar from "./TopBar";
import AdminTopBar from "./AdminTopBar";
import {
  Home,
  Activity,
  Leaderboard,
  Session,
  Profile,
  Klass,
  Calendar,
} from "../pages";
import {
  Activities,
  Administrators,
  Classes,
  Parents,
  Sessions,
  Students,
} from "../pages/admin";

const isAdmin = async () => {
  const account = await firebase
    .firestore()
    .collection("administrators")
    .doc(firebase.auth().currentUser?.uid)
    .get();

  return account.exists;
};

const Routes = () => {
  const [adminEnabled, setAdminEnabled] = useState(false);

  useEffect(() => {
    isAdmin().then(setAdminEnabled);
  }, []);

  return (
    <div>
      {adminEnabled && <AdminTopBar />}
      {!adminEnabled && <TopBar />}
      <Switch>
        <Route path="/" exact component={adminEnabled ? Calendar : Home} />
        <Route path="/home" exact component={Home} />
        <Route path="/activity/:activityId" exact component={Activity} />
        <Route path="/session/:sessionId" exact component={Session} />
        <Route path="/class/:classId" exact component={Klass} />
        <Route
          path="/class/:classId/session/:sessionId"
          exact
          component={Session}
        />
        <Route
          path="/class/:classId/activity/:activityId"
          exact
          component={Activity}
        />
        <Route path="/leaderboard" exact component={Leaderboard} />
        <Route path="/calendar" exact component={Calendar} />
        <Route path="/profile" exact component={Profile} />
        {adminEnabled && (
          <>
            <Route path="/admin" exact component={Calendar} />
            <Route path="/admin/activities" exact component={Activities} />
            <Route path="/admin/admins" exact component={Administrators} />
            <Route path="/admin/classes" exact component={Classes} />
            <Route path="/admin/parents" exact component={Parents} />
            <Route path="/admin/sessions" exact component={Sessions} />
            <Route path="/admin/students" exact component={Students} />
          </>
        )}
        <Route component={Home} />
      </Switch>
    </div>
  );
};

export default Routes;
